module.exports = __webpack_public_path__ + "static/media/Geoquant_Logo_Digital_White.de3da471.svg";